import React from 'react';
import { withTranslation } from 'react-i18next';
import { LOGIN_IMAGE_DATA } from '../../../shared/utils/constants';

const AccessImageWrapper = () => {
  // eslint-disable-next-line no-unused-vars
  const openUrl = (uri) => {
    window.open(uri, '_blank');
  };
  return (
    <div className="access-img-wrapper">
      <div className="mask" />
      <div
        className="img"
        style={{ backgroundImage: `url(${LOGIN_IMAGE_DATA.IMG})` }}
      />
    </div>
  );
};

export default withTranslation('translation')(AccessImageWrapper);
